import * as api from '@yandex-int/k-common/client/api';
import { showNetworkError } from 'platform-components';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { actions } from 'common.components/widgets.course-container/actions';

export function* courseContainerWidgetSagasWatcher() {
    yield all([takeLatest(actions.postLinkCourseContainerToCourseRequest, postLinkCourseContainerToCourseSaga)]);
}

export function* postLinkCourseContainerToCourseSaga(
    action: ReturnType<typeof actions.postLinkCourseContainerToCourseRequest>
) {
    const { courseContainerSlugs, courseId, onSuccess } = action.payload;

    try {
        yield call(api.postLinkCourseContainerToCourse, { courseId, courseContainerSlugs });

        yield put(actions.postLinkCourseContainerToCourseSuccess());

        if (onSuccess) {
            onSuccess();
        }
    } catch (error) {
        const { status } = error;

        yield put(actions.postLinkCourseContainerToCourseError());

        if (status !== 400) {
            yield put(showNetworkError(error));
        } else if (onSuccess) {
            onSuccess();
        }
    }
}
